
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Header } from '@aptsi-types';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-child-parent-hierarchy',
  templateUrl: './child-parent-hierarchy.component.html',
  styleUrls: ['./child-parent-hierarchy.component.scss']
})
export class ChildParentHierarchyComponent {
  @Input() haveUpdateDelete: boolean = true;
  @Input() haveUpdate: boolean = true;
  @Input() haveCapture: boolean = false;
  @Input() haveAdd: boolean = true;
  @Input() isClickDisabled: boolean = false;
  @Input() isDragDropEnabled: boolean = false;
  @Input() headers: Header[];
  @Input() data: any[]; // Parent-child hierarchical data
  @Input() columnStyles: { [key: number]: (value: any) => string } = {}; // Function to map value to style
  @Output() updateClicked = new EventEmitter<number>();
  @Output() deleteClicked = new EventEmitter<any>();
  @Output() addClicked = new EventEmitter<any>();
  @Output() captureClicked = new EventEmitter<number>();
  @Output() checkClicked = new EventEmitter<number>();

  sortDirection: { [key: string]: 'asc' | 'desc' } = {};

  clickedRows: number[] = [];

  constructor() {}

  ngOnInit(): void {}

  onRowClick(index: number) {
    if (this.isClickDisabled && !this.clickedRows.includes(index)) {
      this.checkClicked.emit(index);
      this.clickedRows.push(index);
    }
  }

  toggleHeaderCheckbox(header: any) {
    header.checked = !header.checked;
  }

  check(index: number) {
    this.checkClicked.emit(index);
  }

  update(index: number) {
    this.updateClicked.emit(index);
  }

  delete(datapoint: any, index: number) {
    this.deleteClicked.emit(datapoint);
  }

  add(datapoint: any, index: number) {
    // Emit the datapoint, so the parent component can get the full data
    this.addClicked.emit(datapoint);
  }
  

  capture(index: number) {
    this.captureClicked.emit(index);
  }

  // sortData(property: string) {
  //   this.sortDirection[property] = this.sortDirection[property] === 'asc' ? 'desc' : 'asc';

  //   this.data.sort((a, b) => {
  //     const valueA = a[property];
  //     const valueB = b[property];

  //     if (valueA < valueB) {
  //       return this.sortDirection[property] === 'asc' ? -1 : 1;
  //     } else if (valueA > valueB) {
  //       return this.sortDirection[property] === 'asc' ? 1 : -1;
  //     } else {
  //       return 0;
  //     }
  //   });
  // }

  drop(event: CdkDragDrop<any[]>) {
    if (this.isDragDropEnabled) {
      moveItemInArray(this.data, event.previousIndex, event.currentIndex);
    }
  }

  toggleChildren(datapoint: any): void {
    datapoint.isExpanded = !datapoint.isExpanded;
  }

  getColumnStyle(colIndex: number, cellValue: any): string {
    if (this.columnStyles[colIndex]) {
      return this.columnStyles[colIndex](cellValue);
    }
    return ''; // Return an empty string if no style function is defined for the column
  }
}
